<template>
<div>
  <v-card v-if="false">
    <v-toolbar color="cyan" dark flat>
      <v-app-bar-nav-icon></v-app-bar-nav-icon>
      <v-toolbar-title>{{ chartName }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon>
        <v-icon>mdi-magnify</v-icon>
      </v-btn>
      <v-btn icon>
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </v-toolbar>
    <div style="display: flex; min-height: 220px" loading>
      <div class="n4i-left">
        <div class="total">{{ index() }}</div>
        <div class="y">{{ date() }}</div>
      </div>
      <div
        id="chart_n4index"
        class="chart-box"
        style="padding-bottom: 9px; flex: auto"
      ></div>
    </div>
  </v-card>
    <div class="chart-block">
      <h3>
        {{ chartName }}
        <span>{{ updated }}</span>
      </h3>
      <div id="chart_n4index" class="chart-box" loading></div>
    </div>
  </div>
</template>
<script>
import echarts from "echarts";
import { mapMutations, mapGetters, mapActions, mapState } from "vuex";
export default {
  props: {
    chartName: {
      type: String,
      default: "申请趋势",
    },
  },
  data() {
    return {
      tip: "最近十二个月专利申请趋势",
      chartId: "new4_index",
      chartOption: {},
      myChart: null,
      updated: "",
      marketType: "通过",
      jsonData: null,
      loading: true,
      chartsData: [],
      current: {},
      tabs: ["通过", "驳回", "审核"],
    };
  },
  mounted() {
    //  var js = "{\"date\":\"2020年03月\",\"index\":53.8,\"charts\":[{\"type\":\"新四化整体指数\",\"dict\":{\"19.4\":22,\"19.5\":33,\"19.6\":54,\"19.7\":38,\"19.8\":42,\"19.9\":41,\"19.10\":22,\"19.11\":33,\"19.12\":54,\"20.1\":38,\"20.2\":42,\"20.3\":41}},{\"type\":\"电动化\",\"dict\":{\"19.4\":22,\"19.5\":33,\"19.6\":54,\"19.7\":38,\"19.8\":22,\"19.9\":41,\"19.10\":22,\"19.11\":63,\"19.12\":54,\"20.1\":38,\"20.2\":12,\"20.3\":41}},{\"type\":\"通过\",\"dict\":{\"19.4\":22,\"19.5\":33,\"19.6\":54,\"19.7\":38,\"19.8\":42,\"19.9\":11,\"19.10\":22,\"19.11\":33,\"19.12\":74,\"20.1\":38,\"20.2\":42,\"20.3\":41}},{\"type\":\"智能化\",\"dict\":{\"19.4\":11,\"19.5\":33,\"19.6\":34,\"19.7\":38,\"19.8\":42,\"19.9\":61,\"19.10\":22,\"19.11\":63,\"19.12\":24,\"20.1\":38,\"20.2\":42,\"20.3\":11}}]}";

    this.chartOption = {
      tooltip: {
        formatter: function (params, ticket, callback) {
          return "日期:" + params.name + "<br />指数：" + params.value + "  %";
        },
      },
      grid: {
        left: "4.5%",
        right: "5%",
        bottom: "3%",
        containLabel: true,
      },
      xAxis: {
        type: "category",
        boundaryGap: false, //坐标轴两边留白
        data: [
          "19.4",
          "19.5",
          "19.6",
          "19.7",
          "19.8",
          "19.9",
          "19.10",
          "19.11",
          "19.12",
          "20.1",
          "20.2",
          "20.3",
        ],
        axisLabel: {
          //坐标轴刻度标签的相关设置。
          interval: 0, //设置为 1，表示『隔一个标签显示一个标签』
          //marginLeft:15,
          textStyle: {
            color: "#1B253A",
            fontStyle: "normal",
            fontFamily: "微软雅黑",
            fontSize: 11,
          },
          rotate: 30,
        },
        axisTick: {
          //坐标轴刻度相关设置。
          show: false,
        },
        axisLine: {
          //坐标轴轴线相关设置
          lineStyle: {
            color: "#E5E9ED",
            // opacity:0.2
          },
        },
        splitLine: {
          //坐标轴在 grid 区域中的分隔线。
          show: true,
          lineStyle: {
            color: "#E5E9ED",
            // 	opacity:0.1
          },
        },
      },
      yAxis: [
        {
          type: "value",
          axisLabel: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
          },
        },
      ],
      series: {
        name: "申请趋势",
        type: "line",
        itemStyle: {
          normal: {
            color: "#3A84FF",
            lineStyle: {
              color: "#3A84FF",
              width: 1,
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                {
                  offset: 0,
                  color: "rgba(58,132,255,0)",
                },
                {
                  offset: 1,
                  color: "rgba(58,132,255,0.35)",
                },
              ]),
            },
          },
        },
        data: [22, 23, 33, 44, 46, 49, 34, 32, 45, 25, 35, 12],
      },
    };

    this.queryWidgetByName({
      params: { name: "n4Index" },
      handle: this.updateWidget,
    });
  },
  methods: {
    ...mapActions("widgets", ["queryWidgetByName"]),

    updateWidget(widgetData) {
      this.myChart = echarts.init(document.getElementById("chart_n4index"));
      this.myChart.setOption(this.chartOption);
      window.addEventListener("resize", () => {
        this.myChart.resize();
      });

      this.jsonData = widgetData.jsonData;
      this.bindChart();
    },
    bindChart() {
      var max = this.jsonData.find((x) => x.t == this.marketType);

      this.jsonData.forEach(
        (item) => (max = max.t == item.t && item.date > max.date ? item : max)
      );

      this.current = max;
      this.updated = `最新数据时间 2020-09-08 `;
      this.chartOption.xAxis.data = [];
      this.chartOption.series.data = [];

      var x = this.jsonData.filter((x) => x.t == this.marketType);
      for (var item of x) {
        this.chartOption.xAxis.data.push(item.date.substring(2));
        this.chartOption.series.data.push(item.value);
      }
      this.myChart.setOption(this.chartOption);
      this.loading = false;
    },
  },
  computed: {
    ...mapGetters("widgets", {
      getWidgetByName: "getWidgetByName",
    }),
    index() {
      return function () {
        if (this.current && this.current.value) return this.current.value;
        return 0;
      };
    },
    date() {
      return function () {
        if (this.current && this.current.date) return this.current.date;
        return "...";
      };
    },
  },
  watch: {},
  created() {},
};
</script>
<style scoped>
.n4i-left {
  flex: auto;
  width: 320px;
  text-align: left;
  padding: 20px 0 0 35px;
  position: relative;
}
.n4i-left .total {
  position: absolute;
  color: #5f96e6;
  font-size: 3.5em;
  top: 20%;
}
.n4i-left .y {
  color: #bcbdc1;
  position: absolute;
  bottom: 30%;
}
</style>
 